import React from 'react'

const distribution = () => (
  <svg
    width="501"
    height="124"
    viewBox="0 0 501 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M453.195 116.499V123.995H501V122.998H489.126C476.858 121.67 464.784 119.45 453.195 116.499Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M402.84 97.5619V123.995H450.84V115.888C433.33 111.253 416.988 104.955 402.84 97.5619Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M352.484 59.3562V123.995H400.484V96.3103C393.873 92.7362 387.771 88.9216 382.289 84.9275C376.114 80.4766 367.874 73.1088 358.269 64.5204C356.391 62.8414 354.461 61.1158 352.484 59.3562Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M302.13 19.2743V123.995H350.13V57.2642C335.779 44.5432 319.147 30.349 302.13 19.2743Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M251.775 0V123.995H299.775V17.7634C283.498 7.4735 266.948 0.220043 251.775 0Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M201.42 18.0934V123.995H249.42V0.0222168C234.237 0.522057 217.65 7.86758 201.42 18.0934Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M151.064 57.3981V123.995H199.064V19.5986C181.862 30.7491 165.159 44.934 151.064 57.3981Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M100.71 95.8835V123.995H148.71V59.4857C146.55 61.4047 144.457 63.2749 142.439 65.0781L142.438 65.0786C135.509 71.2701 129.465 76.6715 124.632 80.544C118.198 85.6997 110.088 90.9303 100.71 95.8835Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50.3555 115.372V123.995H98.3555V97.1079C84.5201 104.188 68.1122 110.629 50.3555 115.372Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 123.995V123.284L0 123.282C0.33341 123.268 0.666745 123.253 1 123.237V122.998H5.1434C19.8226 122.006 34.2921 119.511 48 115.989V123.995H1Z"
      fill="#D9E8ED"
    />
  </svg>
)

export default distribution
